import React from 'react';

const AppVideo = () => {
  return <div>AppVideo</div>;
};

export default AppVideo;
